import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

export default class extends Controller {
  static values = {
    url: String,
  };

  initialize() {
    this.isSubmitting = false;
    this.handleBlur = this.saveOnBlur.bind(this);
  }

  connect() {
    this.element.addEventListener("focusout", this.handleBlur);
  }

  disconnect() {
    this.element.removeEventListener("focusout", this.handleBlur);
  }

  saveOnBlur(event) {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    const value = event.target.value;
    const elementName = event.target.name;

    const params = new URLSearchParams();
    params.append(elementName, value);

    patch(`${this.urlValue}?${params}`, {
      responseKind: "turbo-stream",
    }).finally(() => {
      this.isSubmitting = false;
    });
  }
}
